<template>
    <div class="processInstance-batch-add">
        <el-collapse v-model="activeName" accordion>
            <el-collapse-item
                v-for="(process, index) in processBatchStartParamBO.processStartParamBOList"
                :key="process.key"
                :name="process.key">
                <template slot="title" >
                    <div class="button-title">
                        {{process.instanceName}}
                    </div>
                    <div class="form-item-option">
                        <i class="el-icon-delete" @click.stop="handleDeleteItem(index)" title="删除"></i>
                    </div>
                </template>
                 <el-form :ref="'processInstanceForm'+index" size="mini" style="height: 170px; width: 100%; overflow-y: auto;" label-width="120px" class="processInstance-info">
                    <el-row v-if="templateInfo.nameGenerationMode==='single'">
                        <el-col :span="22">
                            <el-form-item label="流程实例名称">
                                <el-input placeholder="请输入内容" v-model="process.instanceName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2">
                            <el-tooltip content="重新获取一个新的流水号" placement="top">
                                <el-button type="primary" class="resetProcessInstance" size="mini" :loading="reSetLoading" icon="el-icon-refresh-right" title="刷新" style="margin-left: 5px;" circle @click="reSetSerialNumber(process)"></el-button>
                            </el-tooltip>
                        </el-col>
                    </el-row>
                    <el-row v-else>
                        <el-col :span="22">
                            <el-form-item label="流程实例名称">
                                <el-input placeholder="请输入流程实例名称" v-model="process.instanceName" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-tooltip  content="当前流程所属上级流程，可以形成流程上下级关系。" effect="light" placement="top">
                            <el-form-item label="上级流程名称">
                                <el-input placeholder="请输入流程实例名称" v-model="process.parentProcessInstanceName" readonly ></el-input>
                            </el-form-item>
                        </el-tooltip>
                    </el-row>
                    <el-row>
                        <el-form-item label="流程负责人">
                            <el-input readonly v-model="process.assignedUserName" @focus="chooseProcessAssigneeUser(index)" ></el-input> 
                            <UserOrgPop :key="loadTimer" :isShowUserOrg="process.isShowProcessUserOrg" :selectedUser="process" :ref="'processUserOrgPop'+index" @nodeClick="processAssigneeSelectTrigger" />
                        </el-form-item>
                        <!-- <el-tooltip  content="默认发起人为流程负责人。批量发起流程模式下，流程负责人会自动设置为首任务负责人。" effect="light" placement="top">
                        </el-tooltip> -->
                    </el-row>
                    <el-row>
                        <el-form-item label="首任务负责人">
                            <el-input readonly v-model="process.firstTaskAssigned.selectedUserNames" @focus="chooseFirstTaskAssigneeUser(index)" ></el-input> 
                            <UserOrgPop :key="loadTimer" :isShowUserOrg="process.isShowTaskUserOrg" :selectedUser="process.firstTaskAssigned" :ref="'taskUserOrgPop'+index" @nodeClick="firstTaskAssigneeSelectTrigger" />
                        </el-form-item>
                    </el-row>
                </el-form>
            </el-collapse-item>
        </el-collapse>
        <el-button type="text" icon="el-icon-circle-plus-outline" plain @click="handleAddItem">添加</el-button>
        <span class="button-group">
            <el-button @click="handleClosePop">取 消</el-button>
            <el-button type="primary" @click="handleSaveStartProcess" :loading="startProcessloading">确 定</el-button>
        </span>
    </div>
</template>
<script>
    import { getUUID } from '@/utils/grocer';
    import { isEmpty } from 'lodash';
    import { getSerialNumber, getProcessServiceTemplate, getAllUserTask, bathStartProcess } from '@/data-model';
    export default {
        data () {
            return {
                reSetLoading: false,
                loadTimer: '',
                currentUserInfo: {},
                curIndex: 0, // 当前流程的index，用于选择负责人
                isShowProcessUserOrg: false,
                activeName: 1,
                startProcessloading: false,
                processBatchStartParamBO: {
                    processInstanceId: '',
                    processInstanceName: '',
                    taskInstanceId: '',
                    processServiceId: '',
                    deploymentId: '',
                    executeType: 1, // 1由已配置的负责人执行   2固定设置所有节点的任务负责人
                    processStartParamBOList: []
                },
                templateInfo: {// 流程模板信息
                    processServiceName: '',
                    processServiceId: '',
                    deploymentId: '',
                    id: '',
                    templateName: '',
                    templateDesc: '',
                    archiveTemplateId: '', // 档案模板
                    archiveTemplateName: '',
                    timeTemplateId: '', // 项目模板
                    timeTemplateName: '',
                    closeTemplateId: '', // 闭环模板
                    closeTemplateName: '',
                    processServiceType: '',
                    nameGenerationMode: '',
                    defaultFirstAssignee: 0, // 是否默认首任务负责人为发起人
                    parentProcessInstanceMode: 0, // 关联上级流程是否必填：0否1是，默认为0
                    processTaskAssignerMode: 0, // 流程所有任务的负责人是否必填：0否1是，默认为0
                    autoCompleteTask: 0,
                    canViewAllFile: 0,
                    claimMode: 0, // 任务认领模式
                    completeFirstTask: 0, // 是否立即执行首任务
                    planTimeMode: 0, // 默认不进行默认计划时间
                    processViewPanes: null,
                    taskViewPanes: null,
                    processExtJson: null,
                    dataOperate: {
                        dataSource: 2,
                        forms: []
                    }
                },
                taskList: []// 所有任务list
            };
        },
        props: {
            taskInfo: {
                type: Object
            }
        },
        created () {
            // console.log(this.taskInfo);
        },
        methods: {
            async _initPage_ (process) {
                // console.log(process);
                // 1、初始化上级流程信息
                if (process.parentProcessInstanceId) {
                    this.processBatchStartParamBO.processInstanceId = process.parentProcessInstanceId;
                    this.processBatchStartParamBO.processInstanceName = process.parentProcessInstanceName;
                }
                this.processBatchStartParamBO.id = process.id;
                this.processBatchStartParamBO.processServiceId = process.processServiceId;
                this.processBatchStartParamBO.deploymentId = process.deploymentId;
                // 2、获取流程模板信息
                await this.getProcessTemplateInfo(process);
                // 3、获取任务list
                this.taskList = [];
                await this.getUserTaskList(process);
                // 4、默认发起人为负责人
                let currentUserStr = sessionStorage.getItem('currentUserInfo');
                this.currentUserInfo = JSON.parse(currentUserStr);
                // 5、初始化第一条流程信息
                this.handleAddItem();
            },
            async handleAddItem () {
                let key = getUUID(16, 16);
                let nodeItem = {
                    key: key,
                    processServiceId: this.processBatchStartParamBO.processServiceId,
                    instanceName: '',
                    deploymentId: this.processBatchStartParamBO.deploymentId,
                    executeType: 1, // 1由已配置的负责人执行   2固定设置所有节点的任务负责人
                    assignedUserId: this.currentUserInfo.userId, // 流程负责人ID
                    assignedUserName: this.currentUserInfo.trueName, // 流程负责人姓名
                    selectedUserIds: this.currentUserInfo.userId,
                    selectedUserNames: this.currentUserInfo.trueName,
                    candidateUsers: '',
                    isShowProcessUserOrg: false,
                    parentProcessInstanceId: this.processBatchStartParamBO.processInstanceId,
                    parentProcessInstanceName: this.processBatchStartParamBO.processInstanceName,
                    relationProcessInstanceId: this.taskInfo.processInstanceId,
                    relationTaskInstanceId: this.taskInfo.id,
                    relationTaskDefinedId: this.taskInfo.taskDefinitionKey,
                    isShowTaskUserOrg: false, // 首任务负责人选择框
                    firstTaskAssigned: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    }
                };
                if (this.templateInfo.nameGenerationMode && this.templateInfo.serialNumberJson) {
                    let node = JSON.parse(this.templateInfo.serialNumberJson);
                    if (this.templateInfo.nameGenerationMode === 'single') { // 单选
                        await this.setSerialNumber(node.value, nodeItem);
                    }
                }
                this.processBatchStartParamBO.processStartParamBOList.push(nodeItem);
                if (this.templateInfo.defaultFirstAssignee) { // 发起人为首任务负责人
                    this.curIndex = this.processBatchStartParamBO.processStartParamBOList.length - 1;
                    let firstTaskAssigned = {selectedUserIds: this.currentUserInfo.userId, selectedUserNames: this.currentUserInfo.trueName};
                    nodeItem.firstTaskAssigned = firstTaskAssigned;
                    this.firstTaskAssigneeSelectTrigger(firstTaskAssigned);
                }
                this.activeName = key;
            },
            async setSerialNumber (sid, node) {
                let numberObj = await getSerialNumber(sid);
                // console.log(numberObj);
                if (numberObj) {
                    node.instanceName = numberObj.newSerialNumber;
                    node.recordId = numberObj.sn;
                }
            },
            async reSetSerialNumber (process) {
                this.reSetLoading = true;
                let node = JSON.parse(this.templateInfo.serialNumberJson);
                if (this.templateInfo.nameGenerationMode === 'single') { // 单选
                    await this.setSerialNumber(node.value, process);
                }
                this.reSetLoading = false;
            },
            handleDeleteItem (index) {
                this.processBatchStartParamBO.processStartParamBOList.splice(index, 1);
            },
            handleClosePop () {
                this.$emit('handleClosePop');
            },
            // 发起流程
            async handleSaveStartProcess () {
                for (let i = 0; i < this.processBatchStartParamBO.processStartParamBOList.length; i++) {
                    let bo = this.processBatchStartParamBO.processStartParamBOList[i];
                    if (isEmpty(bo.instanceName) || bo.instanceName.trim() === '') {
                        this.messageTip('流程名称不能为空', 'warning');
                        return;
                    }
                }
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await bathStartProcess(this.processBatchStartParamBO);
                this.$emit('handleClosePop');
                loading.close();
            },
            // 查询流程模板信息
            async getProcessTemplateInfo  (process) {
                let template = await getProcessServiceTemplate(process.processServiceId, process.deploymentId);
                this.templateInfo.defaultFirstAssignee = template.defaultFirstAssignee;
                this.templateInfo.parentProcessInstanceMode = template.parentProcessInstanceMode;
                this.templateInfo.processTaskAssignerMode = template.processTaskAssignerMode;
                this.templateInfo.autoCompleteTask = template.autoCompleteTask;
                this.templateInfo.canViewAllFile = template.canViewAllFile;
                this.templateInfo.claimMode = template.claimMode;
                this.templateInfo.completeFirstTask = template.completeFirstTask;
                this.templateInfo.processViewPanes = template.processViewPanes;
                this.templateInfo.taskViewPanes = template.taskViewPanes;
                this.templateInfo.processExtJson = template.processExtJson;
                this.templateInfo.planTimeMode = template.planTimeMode;
                this.templateInfo.nameGenerationMode = template.nameGenerationMode ? template.nameGenerationMode : '';
                this.templateInfo.serialNumberJson = template.serialNumberJson ? template.serialNumberJson : '';
                this.templateInfo.firstTaskUserIds = template.firstTaskUserIds; // 首任务taskId的list
            },
            // 查询流程模板的所有任务信息
            async getUserTaskList (process) {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let tasks = await getAllUserTask(null, process.processServiceId, process.id, process.deploymentId);
                this.taskList = tasks;
                loading.close();
            },
            // =========================流程负责人的选择begin=======================
            chooseProcessAssigneeUser (index) {
                this.curIndex = index;
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs['processUserOrgPop' + index][0]._initPage();
                }, 0);
                this.processBatchStartParamBO.processStartParamBOList[index].isShowProcessUserOrg = true;
            },
            processAssigneeSelectTrigger (selected) { // 流程负责人
                this.processBatchStartParamBO.processStartParamBOList[this.curIndex].assigneeUserId = selected.selectedUserIds;
                this.processBatchStartParamBO.processStartParamBOList[this.curIndex].assignedUserName = selected.selectedUserNames;
                // 重置首任务负责人
                // let assignedUserList = [];
                // assignedUserList.push({taskId: this.taskList[0].taskId, taskName: this.taskList[0].taskName, assignedUserId: selected.selectedUserIds, assigneeUserName: selected.selectedUserNames});
                // this.processBatchStartParamBO.processStartParamBOList[this.curIndex].assignedUserList = assignedUserList;
                this.loadTimer = new Date().getTime();
            },
            // =========================流程负责人的选择end=========================
            // =========================首任务负责人的选择begin=======================
            chooseFirstTaskAssigneeUser (index) {
                this.curIndex = index;
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs['taskUserOrgPop' + index][0]._initPage();
                }, 0);
                this.processBatchStartParamBO.processStartParamBOList[index].isShowTaskUserOrg = true;
            },
            firstTaskAssigneeSelectTrigger (selected) { // 首任务负责人
                // 重置首任务负责人
                let assignedUserList = [];
                for (let i = 0; i < this.templateInfo.firstTaskUserIds.length; i++) {
                    let taskNode = {};
                    taskNode.taskId = this.templateInfo.firstTaskUserIds[i];
                    taskNode.assignedUserId = selected.selectedUserIds;
                    taskNode.assigneeUserName = selected.selectedUserNames;
                    assignedUserList.push(taskNode);
                }
                // assignedUserList.push({taskId: this.taskList[0].taskId, taskName: this.taskList[0].taskName, assignedUserId: selected.selectedUserIds, assigneeUserName: selected.selectedUserNames});
                this.processBatchStartParamBO.processStartParamBOList[this.curIndex].assignedUserList = assignedUserList;
                this.loadTimer = new Date().getTime();
            },
            // =========================首任务负责人的选择end=========================
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            }
        }
    };
</script>


<style lang="less">
    .processInstance-batch-add {
        display: flex;
        flex-direction: column;
        .item-form {
            height:170px;
            width:100%;
            overflow-y:auto;
        }
        .resetProcessInstance {
            vertical-align: middle;
            margin-left: 5px;
        }
        .el-collapse {
            border-left: 1px solid #ebeef5;
            border-right: 1px solid #ebeef5;
        }
        .button-title {
            padding: 0 0 0 10px;
            flex:1;
        }
        .form-item-option {
            // position: absolute;
            // right: 50px;
            width: 20px;
            cursor: pointer;
            display: block;
        }
        .button-list {
            display: flex;
            flex-direction: column;
        }
        .processInstance-info {
            width: 600px;
            // padding-right: 20px;
        }
        .button-group {
            text-align: right;
            margin-top: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ProcessInstanceBatchAddPop/ProcessInstanceBatchAddPop.vue